<template>
    <div class="balcao-view-corpo">

        <MenuTopTemplate :titulo="''"/>

        <div v-if="this.pagamento_confirmado == false">
            <p>Sua solicitação de pagamento ainda não foi confirmada.</p>
            <MpStatusScreenPix :pix_data="pix_qr_code" :data_hora_qrcode="pix_qr_code_horario"/>

        </div>


        <div v-if="this.pagamento_confirmado == true">
            <div class="card">
                <p>Seu pedido já foi enviado!</p>
                <p>Fique atento ao status do seu pedido.</p>

                <br>
                
                <div>
                    <div style="font-size: 16px;">Senha</div>
                    <div style="font-size: 26px;">{{ this.senha_pedido }}</div>
                </div>
                
                <br>
                
                <div>
                    <div style="font-size: 16px;">Status</div>
                    <div style="font-size: 16px;">{{ this.status_pedido }}</div>
                </div>
                
                <br>
            </div>

     
        </div>



        <BalcaoPedidoItens :json_pedido="json_pedido"/>

      
 
    </div>
</template>

<script>
/* eslint-disable */
import MenuTopTemplate from "@/components/Base/MenuTopTemplate.vue";
import ApiDelivery from "../api/ApisDelivery"
import TelefoneComDDD from '@/components/Delivery/TelefoneComDDD.vue';
import BalcaoSucessoView from "./BalcaoSucessoView.vue";
import { setarCores } from '@/utils/SetarCores';
import MpPagamento from '@/components/mercadopago/MpPagamento.vue';
import MpStatusScreenPix from '@/components/mercadopago/MpStatusScreenPix.vue';
import BalcaoPedidoItens from "@/components/Balcao/BalcaoPedidoItens.vue";
export default {
    name: "BalcaoStatusView",

    data() {
        return {
            telefone : null,
            pix_qr_code: null,
            pix_qr_code_horario: null,
            
            pagamento_confirmado: false,
            senha_pedido: null,
            status_pedido: null,

            json_pedido: null
        };
    },

    created() {
        this.iniciarParams();
        setarCores(this.$store.state.cor1, this.$store.state.cor2, this.$store.state.corTexto)

        setTimeout(() => {
            console.log("COMECEI O MERCADO PAGO")
            this.iniciarMercadoPago = true


        }, 2000);
    },

    watch: {

    },

    computed: {
       
    },

    methods: {
        iniciarParams() {
            this.telefone = this.$route.query.telefone;
            this.pix_qr_code = this.$route.query.pix_qr_code;
            this.pix_qr_code_horario = this.$route.query.pix_qr_code_horario;



            this.checarStatusPix()
        },

       
        /**
         * retorna 
         * {
            "Id": 1,
            "cliente_telefone": 123456,
            "status": "0",
            "senha": "555",
            "pagamento_web_aprovado": false,
            "idPedidoMercadoPago": "123465",
            "dataHoraPedido": "2026-04-27T16:27:20.000000Z",
            "pagamentoConfirmado": false,
            "idAndroidOperacaoCLOUD": 0,
            "numeroEmpresa_FK": 1,
            "json": null,
            "resposta_mercado_pago": null
        }
         */
        checarStatusPix() {
            ApiDelivery.balcaoWebChecarStatusPixComTelefone(this.telefone, this.$store.state.cnpj).then(res => {

                console.log("--------------------------------")
                console.log("Status do pix:")
                console.log(res)

                this.senhaPedido = res.senha;
                this.pedidoEnviado = true;
                this.loading = false;
                this.$store.commit("SET_LIMPAR_ITENS_CARRINHO");

                this.json_pedido = JSON.parse(res.json);

                this.pagamento_confirmado = res.pagamento_web_aprovado;
                this.senha_pedido = res.senha;
                this.status_pedido = res.status == 0 || res.status == "0" ? "Aguardando produção" : "Pronto para retirada";

                if (res.status == 0 || res.status == "0") {
                    
                    setTimeout(() => {
                        this.checarStatusPix()
                    }, 6000);
                }
            }).catch(err => {
                console.log("Erro ao checar status do pix:")
                console.log(err)
            })
        },


    },

    components: { MenuTopTemplate, TelefoneComDDD,  BalcaoSucessoView, MpPagamento, MpStatusScreenPix, BalcaoPedidoItens }
}
</script>

<style scoped>
.balcao-view-corpo {
    color: white;
}

p {margin: 2px}
.card {
    font-size: 15px;
    color: black;
    margin-inline: 15px;
    border: white solid 2px;
    padding: 15px;
    border-radius: 5px;
    background: white;
    animation: card-anim 0.5s forwards;
}

@keyframes card-anim {
    from { opacity: 0; transform: translateX(-30%) }
    to { opacity: 1; transform: translateX(0%)}
}

.resumo-pedido span {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
}
.img-loading-container {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
</style>



